import { render, staticRenderFns } from "./viewFileMin.vue?vue&type=template&id=1bf65b6f&scoped=true"
import script from "./viewFileMin.vue?vue&type=script&lang=js"
export * from "./viewFileMin.vue?vue&type=script&lang=js"
import style0 from "./viewFileMin.vue?vue&type=style&index=0&id=1bf65b6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf65b6f",
  null
  
)

export default component.exports